import { useState, useEffect } from 'react';
import { moduleClientFactory } from '../../api-service/module-client-factory';
import { useTenantConfiguration } from '../use-tenant-configuration';

const configurationClient = moduleClientFactory.createConfigurationClient();

export function useAiDemoEmailDomainAccess() {
  const { hasAiDemoEmailDomainWhitelist } = useTenantConfiguration();
  const [isWhitelistedDomain, setIsWhitelistedDomain] = useState<boolean>(false);

  useEffect(() => {
    if (hasAiDemoEmailDomainWhitelist !== true) {
      return undefined;
    }

    let isMounted = true;

    async function checkEmailDomainAccess() {
      try {
        const response = await configurationClient.getIsAiDemoEmailDomainAllowed();
        if (isMounted && response?.isAllowed) {
          setIsWhitelistedDomain(true);
        }
      } catch {
        // Fail closed: a failed lookup must not expose the AI features
      }
    }

    checkEmailDomainAccess();

    return () => {
      isMounted = false;
    };
  }, [hasAiDemoEmailDomainWhitelist]);

  const isAiDemoEmailDomainAllowed = hasAiDemoEmailDomainWhitelist === false || isWhitelistedDomain;

  return { isAiDemoEmailDomainAllowed };
}
